import { IDepartmentData, IDepartmentFieldErrorData } from '../department';
import { State } from '../state/state';
import { IUserData } from '../user';

export interface IFormFieldType {
  value: FormFieldTypeEnum;
  text: string;
  icon: string;
}
export interface IFormTemplateData {
  id?: number;
  title: string;
  description: string;
  state: IFormTemplateStatus | FormTemplateStateEnum;
  sections?: IFormSectionData[];
  owner?: string;
  created_at?: string | Date;
  updated_at?: string | Date;
}

export interface IFormSectionData {
  id?: number;
  title: string;
  order: number;
  section_fields: IFormSectionFieldData[];
}

export interface IFormSectionFieldData {
  id?: number;
  field_template: IFormFieldData | number;
  required: boolean;
  disabled: boolean;
  order: number;
  width: number;
  create_todo: boolean;
  constraints: IFormSectionFieldConstraintData[];
}

export interface IFormSectionFieldConstraintData {
  id?: number;
  action: ConstraintActionEnum;
  conditions: IFormSectionFieldConstraintConditionData[];
}

export interface IFormSectionFieldConstraintConditionData {
  id?: number;
  field_option: number;
  form_section_field: number;
}

export interface IFormFieldData {
  id?: number;
  label: string;
  meta_label: string;
  hint: string;
  type: FormFieldTypeEnum;
  options?: IFormFieldOptionData[];
}

export interface IFormFieldOptionData {
  id?: number;
  field: number;
  value: string;
  order: number;
}

export interface IFormFieldOptionTodoData {
  id?: number;
  field_option: number;
  todo_template: IFormFieldOptionTodoTemplateData | number;
  section_field: number;
}

export interface IFormFieldOptionTodoTemplateData {
  id?: number;
  todo_text: string;
  todo_department: IDepartmentData | number;
  assignee: IUserData | number;
  order: number;
}

export interface IFormTemplateStatusData {
  value: FormTemplateStateEnum;
  display_name?: string;
}

export interface IFormTemplateStatus extends IFormTemplateStatusData {
  getCurrentState(): State<FormTemplateStateEnum>;
}

export interface IFormSectionField extends IFormSectionFieldData {
  validate(): boolean;
}

export interface IFormSection extends IFormSectionData {
  validate(): boolean;
}

export interface IFormField extends IFormFieldData {
  validate(): boolean;
}

export interface IFormFieldOptionTodo extends IFormFieldOptionTodoData {
  validate(): boolean;
}

export interface IFormTemplate extends IFormTemplateData {
  created_at?: Date;
  updated_at?: Date;

  validate(): boolean;
}

export interface IFormFieldOption extends IFormFieldOptionData {
  validate(): boolean;
}

export interface IFormSectionFieldConstraint
  extends IFormSectionFieldConstraintData {
  validate(): boolean;
}

export interface IFormSectionFieldConstraintCondition
  extends IFormSectionFieldConstraintConditionData {
  validate(): boolean;
}

export interface IFormFieldOptionTodoTemplate
  extends IFormFieldOptionTodoTemplateData {
  validate(): boolean;
}

export interface IFormTemplateFieldErrorData {
  title: string[];
  description: string[];
  sections?: IFormSectionFieldErrorData[];
  owner?: string[];
}

export interface IFormSectionFieldErrorData {
  title: string[];
  order: string[];
  section_fields: IFormSectionFieldFieldErrorData[];
}

export interface IFormSectionFieldFieldErrorData {
  field: IFormFieldFieldErrorData[];
  order: string[];
  width: string[];
}

export interface IFormFieldFieldErrorData {
  label: string[];
  meta_label: string[];
  hint: string[];
  type: string[];
  order: string[];
  required: string[];
  create_todo: string[];
  todo_department: IDepartmentFieldErrorData[];
  options?: IFormFieldOptionFieldErrorData[];
  style?: IFormFieldStyleFieldErrorData[];
}

export interface IFormFieldOptionFieldErrorData {
  value: string[];
  order: string[];
  todo_text: string[];
}

export interface IFormFieldStyleFieldErrorData {
  width: string[];
}

export interface IFormTemplateFieldError extends IFormTemplateFieldErrorData {
  clearErrors(): void;
}

export interface IFormSectionFieldError extends IFormSectionFieldErrorData {
  clearErrors(): void;
}

export interface IFormSectionFieldFieldError
  extends IFormSectionFieldFieldErrorData {
  clearErrors(): void;
}

export interface IFormFieldFieldError extends IFormFieldFieldErrorData {
  clearErrors(): void;
}

export interface IFormFieldOptionFieldError
  extends IFormFieldOptionFieldErrorData {
  clearErrors(): void;
}

export interface IFormFieldStyleFieldError
  extends IFormFieldStyleFieldErrorData {
  clearErrors(): void;
}

export enum FormFieldTypeEnum {
  Label,
  Textfield,
  Textarea,
  Combobox,
  Checkbox,
  Radiobutton,
  DatePicker,
  FileField
}

export enum ConstraintActionEnum {
  Required,
  Optional,
  Disabled
}

export enum FormTemplateStateEnum {
  Draft,
  Published
}
